module.exports = __webpack_public_path__ + "img/Crown of thorns seastar.1148a567.png";